<template>
  <header class="header">
    <main class="header-main" :style="{ width }">
      <div class="header-main__left">
        <YorkbbsImage
          width="112px"
          height="34.4px"
          :src="require('@/assets/images/common/logo_image.png')"
          target="_blank"
          alt="约克论坛:加拿大第一中文网！"
          :link="`/` | hostBuild('www')"
        ></YorkbbsImage>
        <ul class="header-nav__list">
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('www')" title="首页" target="_blank">首页</a>
          </li>
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('news')" title="新闻" target="_blank">新闻</a>
          </li>
          
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('house')" title="房产" target="_blank">房产</a>
          </li>
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('car')" title="汽车" target="_blank">汽车</a>
          </li>
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('info')" title="黄页" target="_blank">黄页</a>
          </li>
          <li class="header-nav__item">
            <a :href="`/restaurantlist/restaurants` | hostBuild('info')" title="美食" target="_blank">美食 </a>
          </li>
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('job')" title="招聘" target="_blank">招聘</a>
          </li>
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('forsale')" title="二手" target="_blank">二手</a>
          </li>
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('forum')" title="论坛" target="_blank">论坛</a>
          </li>
        </ul>
      </div>
      <div class="header-main__right" v-if="isLogin">
        <div class="header-user" @mouseenter="userCardVisible = true" @mouseleave="userCardVisible = false">
          <YorkbbsImage
            class="header-user__avatar"
            :src="avatar | webpFormat(50)"
            :link="homeURL"
            target="_blank"
            v-if="avatar"
          ></YorkbbsImage>
          <i class="yk-house_user" v-else></i>
          <transition name="fade-in">
            <YorkbbsUserCard
              v-show="userCardVisible"
              :balance="balance"
              :myAttentionCount="myAttentionCount"
              :myFansCount="myFansCount"
              :oldIntegral="oldIntegral"
              @logout="onLogout"
            ></YorkbbsUserCard>
          </transition>
        </div>
        <div class="header-notice__list">
          <div class="header-notice__item">
            <el-popover trigger="hover" popper-class="header-notice__popover" placement="bottom" :width="150">
              <button class="header-notice__box" slot="reference">
                <i class="yk-notice"></i>
                <span class="header-notice__num" v-if="noticeNum">{{ noticeNum | noticeNumFilter }}</span>
              </button>
              <YorkbbsNoticeCard
                :atUserCount="atUserCount"
                :commentNoticeCount="commentNoticeCount"
                :systemNoticeCount="systemNoticeCount"
                :thumbUpCount="thumbUpCount"
                :attentionToMeCount="attentionToMeCount"
              ></YorkbbsNoticeCard>
            </el-popover>
          </div>
          <div class="header-notice__item chat">
            <a class="header-notice__box" :href="'/chat' | hostBuild('home')" target="_blank">
              <i class="yk-information"></i>
              <span class="header-notice__num" v-if="chatUnReadNum">{{ chatUnReadNum | noticeNumFilter }}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="header-main__right" v-else>
        <el-button size="medium" type="danger" @click="$store.commit('showLoginDialog')">登录</el-button>
        <a class="header-button" :href="'/regist' | hostBuild('account')" target="_blank">
          <el-button size="medium">注册</el-button>
        </a>
      </div>
    </main>
  </header>
</template>
<script>
import { hostBuild } from '@/utils/utils';
import { logoutMixin } from '@/utils/logout.mixin';
import TIM from 'tim-js-sdk';
import YorkbbsUserCard from './card-user.vue';
import YorkbbsNoticeCard from './card-notice.vue';
export default {
  name: 'Header',
  mixins: [logoutMixin],
  props: {
    // 退出登录后跳转的地址
    logoutURL: String,
    // 内容区域宽度
    width: {
      type: String,
      default: '990px',
    },
  },
  components: { YorkbbsUserCard, YorkbbsNoticeCard },
  data() {
    return {
      // 私信数量
      letterNum: 0,
      // 系统通知数量
      systemNoticeCount: 0,
      // 评论通知数量
      commentNoticeCount: 0,
      // @我的数量
      atUserCount: 0,
      // 关注我的数量
      attentionToMeCount: 0,
      // 赞我的数量
      thumbUpCount: 0,
      // 余额，分
      balance: 0,
      // 关注数
      myAttentionCount: 0,
      // 粉丝数
      myFansCount: 0,
      // 积分
      oldIntegral: 0,
      // 用户详情显示状态
      userCardVisible: false,

      // 私信未读数量
      chatUnReadNum: 0,

      //私信客户端
      tim:null,
      //tim定时退出
      timTimeout:null,
    };
  },
  computed: {
    // 是否登录
    isLogin() {
      return this.$store.getters.isLogin;
    },
    // 用户头像
    avatar() {
      return this.$store.getters.user.avatar;
    },
    // 用户ID
    userId() {
      return this.$store.getters.user.id;
    },
    // 用户名
    username() {
      return this.$store.getters.user.username;
    },
    // 用户主页
    homeURL() {
      return hostBuild(`/home/${this.userId}`, 'home');
    },
    // 通知总数量
    noticeNum() {
      return (
        this.atUserCount +
        this.commentNoticeCount +
        this.systemNoticeCount +
        this.thumbUpCount +
        this.attentionToMeCount
      );
    },
  },
  filters: {
    noticeNumFilter(num) {
      return num > 99 ? '99+' : num;
    },
  },
  watch: {
    isLogin: {
      immediate: true,
      handler(isLogin) {
        if (isLogin) {
          this.getMessage();
          this.getMyInfo();

        }
      },
    },
  },
  created(){
    
    //this.tim = TIM.create({ SDKAppID: process.env.NODE_ENV === 'production'?1400495074:1400734830 });
    this.tim = TIM.create({ SDKAppID: 1400495074 });
    this.tim.setLogLevel(4);
    // 收到会话列表更新通知
    this.tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, this.updateChatUnReadNum);
  },
  methods: {
    /**
     * 获取个人信息
     */
    async getMyInfo() {
      const { data } = await this.$axios.post('/user/v1/get/my/info');
      this.balance = data.balance;
      this.myAttentionCount = data.myAttentionCount;
      this.myFansCount = data.myFansCount;
      this.oldIntegral = data.oldIntegral;

      this.timInit();
    },
    /**
     * 获取消息数量
     */
    async getMessage() {
      const { data } = await this.$axios.post('/user/v1/get/my/unread/notice/count');
      this.systemNoticeCount = data.systemNoticeCount;
      this.atUserCount = data.atUserCount;
      this.commentNoticeCount = data.commentNoticeCount;
      this.thumbUpCount = data.thumbUpCount;
      this.attentionToMeCount = data.attentionToMeCount;
    },
    /**
     * 退出登录
     */
    onLogout() {
      this.logout(this.logoutURL || '/');
      this.userCardVisible = false;
    },
    /**
     * 获取私信未读信息数量
     */
    async getChatUnReadNum() {
      
      

    },
    async updateChatUnReadNum(event){
      
      let unreadNum = 0;
      (event.data || []).forEach(item => {
        unreadNum += item.unreadCount;
      });
      this.chatUnReadNum = unreadNum;
      clearTimeout(this.timTimeout);
      this.timTimeout = setTimeout(()=>{
        if( window.location.pathname != '/chat'){
          this.tim.logout();
        }
      },2000)
      /* if( window.location.pathname != '/chat'){
        this.tim.logout();
      } */
    },
    async timInit(){
     
      const { data } = await this.$axios.post('/webim/manage/get/sign', {
        user: this.$store.getters.user.id,
      });

      await this.tim
        .login({
          userID: this.$store.getters.user.id.replace(/-/g, ''),
          userSig: data,
        })
        .catch(e => console.error(e));
    },
    
  },
};
</script>
<style lang="scss" scoped>
.header {
  background-color: #fafafa;
  border-bottom: 1px solid #efefef;
}
.header-main {
  height: 64px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}
.header-main__left {
  display: flex;
  align-items: center;
}
.header-nav__list {
  display: flex;
  margin-left: 22px;
}
.header-nav__item {
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  color: #333333;
  margin-right: 34px;
  a {
    &:hover {
      color: var(--primary-color);
    }
  }
}
.header-main__right {
  display: flex;
  align-items: center;
}
.header-notice__list {
  display: flex;
}
.header-notice__item {
  position: relative;
  padding: 5px;
  border-radius: 50%;
  &:hover {
    background-color: #ddd;
  }
  &.chat {
    margin-left: 30px;
  }
}
.header-notice__box {
  i {
    font-size: 20px;
  }
}
.header-notice__num {
  position: absolute;
  top: -3px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #fff;
  background-color: #e43a3a;
  border-radius: 8px;
  padding: 0 5px;
  left: 18px;
}
.header-user {
  margin-right: 30px;
  position: relative;
  &:hover {
    .header-user__avatar {
      animation: slideDown 0.2s linear forwards;
    }
  }
}
.header-user__avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.yk-house_user {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  font-size: 20px;
}
.header-button {
  margin-left: 10px;
}

@keyframes slideDown {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(10%);
  }
}

.fade-in-enter,
.fade-in-leave,
.fade-in-leave-active {
  opacity: 0;
}

.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity 0.2s linear 0.2s;
}
</style>
<style lang="scss">
.header-notice__popover {
  padding: 0;
}
</style>
